.list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: var(--tempest-space-2);
}

.item {
    margin: 0;
}
